"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
require("./filterBlock.scss");
const FilterBlock = (props) => {
    return (react_1.default.createElement(core_1.Box, { id: 'filter-block', className: props.className },
        react_1.default.createElement("h5", { className: 'title' }, props.title),
        props.children));
};
exports.default = FilterBlock;
